var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dv-border-box-12',{staticClass:"item-container"},[_c('div',{staticClass:"item-title"},[_vm._v("产废企业总量TOP 5")]),_c('my-scroll-ranking-board',{attrs:{"config":_vm.config,"click":_vm.click}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }